// What a finished test's card says and which buttons it offers. The release rule is set per
// school and per test ("Right after they finish", "After a counselor releases each result",
// "Keep all results hidden"); the server reports it as released / in_review / not_shared.

export const STATUS = {
  RELEASED: 'released',
  IN_REVIEW: 'in_review',
  NOT_SHARED: 'not_shared',
  SAVE_FAILED: 'save_failed',
};

const KNOWN = Object.values(STATUS);

/**
 * The plan for one finish card.
 * message: which sentence to show; primary: the dark button; secondary: the ghost buttons.
 * Worrying answers win over every release rule, and never show scores.
 */
export const finishPlan = ({ status, worrying = false, nextTest = null }) => {
  const known = KNOWN.includes(status) ? status : STATUS.IN_REVIEW;
  if (known === STATUS.SAVE_FAILED) {
    return { message: 'save_failed', primary: 'retry', secondary: [], crisis: false, allDone: false };
  }
  if (worrying) {
    return { message: 'worry', primary: 'book', secondary: ['done'], crisis: true, allDone: false };
  }
  const allDone = !nextTest;
  if (known === STATUS.RELEASED) {
    return {
      message: 'released',
      primary: 'results',
      secondary: nextTest ? ['next', 'counselor'] : ['counselor', 'done'],
      crisis: false,
      allDone,
    };
  }
  if (known === STATUS.NOT_SHARED) {
    return {
      message: 'not_shared',
      primary: 'counselor',
      secondary: nextTest ? ['next', 'done'] : ['done'],
      crisis: false,
      allDone,
    };
  }
  return {
    message: 'in_review',
    primary: nextTest ? 'next' : 'done',
    secondary: nextTest ? ['counselor', 'done'] : ['counselor'],
    crisis: false,
    allDone,
  };
};

/** Booking reason for "Talk to a counselor": a follow-up only when the student can see the result. */
export const counselorReason = ({ status, worrying, followupReason, fallbackReason = 'general' }) => {
  if (worrying) return 'personal';
  if (status === STATUS.RELEASED && followupReason) return followupReason;
  return fallbackReason;
};
